import { Component, OnInit } from '@angular/core';
import { Store } from '@ngxs/store';
import { Navigate } from '@ngxs/router-plugin';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

/* State and Services */
import { Login } from '@core/store/auth/auth.action';

/* Models */
import { AuthObj } from '@core/models/user.model';

@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
	error = false;
	loading = false;
	tfaFlag = false;
	adminAuthenticated = undefined;

	loginForm = new UntypedFormGroup({
		username: new UntypedFormControl('', Validators.required),
		password: new UntypedFormControl('', Validators.required),
	});
	authForm = new UntypedFormGroup({
		authCode: new UntypedFormControl(null, [Validators.required, Validators.minLength(6), Validators.maxLength(6)]),
	});

	constructor(private store: Store) {}

	ngOnInit(): void {}

	onLogin(customerId: number = undefined) {
		this.error = null;
		this.loading = true;

		// angular cannot be trusted to update values properly on autocomplete, fetch directly from element when missing
		let v = this.loginForm.value;
		let username = v.username || (document.getElementById('username') as HTMLInputElement).value;
		let password = v.password || (document.getElementById('password') as HTMLInputElement).value;

		const authObj: AuthObj = {
			adminAuthenticated: this.adminAuthenticated,
			customerId,
			username,
			password,
			...this.authForm.value,
		};
		this.store.dispatch(new Login(authObj)).subscribe({
			next: () => this.store.dispatch(new Navigate(['/'])),
			error: (err) => this.handleLoginError(err),
		});
	}

	handleLoginError(errorMessage: string) {
		this.error = true;
		this.loading = false;

		switch (errorMessage) {
			case 'Admin Login Initiated':
				this.adminAuthenticated = true;
				break;
			case 'TFA Login Initiated':
				this.tfaFlag = true;
				break;
			case 'Invalid Auth Code':
				this.authForm.setErrors({ invalidAuthCode: true });
				break;
			default:
				this.loginForm.setErrors({ invalidCredidentials: true });
				break;
		}
	}
}
